import ProtectedRoute from "@commons/layouts/ProtectedRoute";
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { adminRoutes } from "./routes/admin.route";
import { storeRoutes } from "./routes/store.route";
import Dashboard from "@pages/admin/dashboard";
import StoreDashboard from "@pages/store/dashboard";
import ScrollToTop from "@components/scrolltotop";
import Login from "@commons/auth/Login";
import PaymentStatus from "./pages/front/paymentStatus";
import PaymentStatusSuccess from "./pages/front/paymentStatus/success";
import PaymentStatusFailed from "./pages/front/paymentStatus/failed";
import ReferralPage from "./pages/front/referral";
import PageViewer from "./pages/front/page-viewer";
import Loader from "@components/loader";

const AdminLayout = lazy(
  () => import("@commons/layouts/private/admin/AdminLayout"),
);
const StoreLayout = lazy(
  () => import("@commons/layouts/private/store/StoreLayout"),
);

import { SocketProvider } from "@context/SocketContext";
import { CallProvider } from "@context/CallContext";
import useAutoLogout from "./hooks/useAutoLogout";

const App = () => {
  useAutoLogout();
  return (
    <SocketProvider>
      <CallProvider>
        <ScrollToTop />
        <Suspense fallback={<Loader fullScreen />}>
          <Routes>
            <Route path="/" element={<Navigate to="/admin-login" replace />} />
            <Route path="/admin-login" element={<Login role="admin" />} />
            <Route path="/store-login" element={<Login role="store" />} />
            <Route
              path="/payment-status/:method/:refId/:requestId"
              element={<PaymentStatus />}
            />
            <Route
              path="/referral"
              element={<ReferralPage />}
            />
            <Route
              path="/privacy-policy"
              element={<PageViewer />}
            />
            <Route
              path="/terms-of-service"
              element={<PageViewer />}
            />
            <Route
              path="/refund-policy"
              element={<PageViewer />}
            />
            <Route
              path="/contact-us"
              element={<PageViewer />}
            />
            <Route
              path="/payment-status/:method/:refId/:requestId/success"
              element={<PaymentStatusSuccess />}
            />
            <Route
              path="/payment-status/:method/:refId/:requestId/failed"
              element={<PaymentStatusFailed />}
            />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute
                  allowedRoles={["admin"]}
                  Component={AdminLayout}
                />
              }
            >
              <Route index element={<Dashboard />} />
              {adminRoutes.map((item, i) => (
                <Route {...item} key={`admin-${i}`} />
              ))}
            </Route>

            <Route
              path="/store/*"
              element={
                <ProtectedRoute
                  allowedRoles={["store"]}
                  Component={StoreLayout}
                />
              }
            >
              <Route index element={<StoreDashboard />} />
              {storeRoutes.map((item, i) => (
                <Route {...item} key={`store-${i}`} />
              ))}
            </Route>
          </Routes>
        </Suspense>
      </CallProvider>
    </SocketProvider>
  );
};

export default App;
